import router from './router'
import {getToken} from '@/utils/auth' // get token from cookie
import {getCookie} from '@/utils/cookie'
import store from "./store"

const whiteList = ['/test/testui', '/forgetPassword', '/404']; // no redirect whitelist


router.beforeEach((to, from, next) => {
  const token = getToken();
  if (!store.getters.menus && !!token && token.indexOf("$") === -1) {
    store.dispatch('getUserInfo').then(r=>{
      beforeEach(to, from, next);
    });
  } else {
    beforeEach(to, from, next)
  }


});

function beforeEach(to, from, next) {
  const userStatus = getCookie('userStatus');
  if (whiteList.indexOf(to.path) !== -1 || to.path === getCookie('index')) {
    next()
  } else {
    if (userStatus && userStatus === "1") {
      if (to.path.indexOf('/seisp_service') > -1) {
        next()
      } else {
        try {
          findRouter(router.options.routes, to.path);
          next({path: '/404'})
        } catch (e) {
        }
        const hasToken = getToken();

        // 访问白名单中的路由可以直接访问
        if (whiteList.indexOf(to.path) !== -1) {
          next()
        } else {
          // 如果有token
          if (hasToken) {
            // token中包含“$”说明未登录
            if (hasToken.indexOf("$") !== -1) {
              window.location.href = "/static/login.html";
            } else {
              next()
            }
          }
          // 如果没有token，都导向登录页
          else {
            window.location.href = "/static/login.html";
          }
        }
      }
    } else {
      if (userStatus === "2" && to.path === getCookie('index')) {
        next({path: getCookie('index')})
      } else {
        window.location.href = "/static/login.html";
      }
    }
  }
}

function findRouter(routers, routerPath) {
  try {
    routers.some(item => {
      if (item.path === routerPath) {
        throw new Error('End')
      } else {
        if (item.children) {
          findRouter(item.children, routerPath)
        }
      }
    })

  } catch (e) {
    if (e.message === 'End') throw e;
  }
}

export default {whiteList}



// WEBPACK FOOTER //
// ./src/permission.js